import FileViewerModal from 'components/modal/file-viewer-modal';
import { useSyncSelectedProject } from 'hooks/useSyncSelectedProject';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { useGetShowCabinetFileURLQuery } from 'redux-store/api/file-cabinet';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { authSelector } from 'redux-store/selector';

export const FileItemHashtagModal = ({
  projectId,
  onClose,
}: {
  projectId: number;
  onClose: () => void;
}) => {
  const { id, mimeType } = useAppSelector((state) => state.hashtag.fileItem);
  const { companyId } = useAppSelector(authSelector);
  const { project } = useSyncSelectedProject(projectId);

  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery(undefined, {
    skip: !companyId,
  });

  const { data: fileData } = useGetShowCabinetFileURLQuery({
    fileId: id,
    ...(projectId && { projectId }),
  });

  if (!userPermissions?.VIEW_PROJECT_FOLDERS?.canRead) return null;

  return (
    <FileViewerModal
      mimeType={mimeType}
      url={fileData?.url || ''}
      handleClose={onClose}
      open
      fileId={id}
      project={project}
    />
  );
};
